import { render, staticRenderFns } from "./Departments.vue?vue&type=template&id=0d374bab&scoped=true&"
import script from "./Departments.vue?vue&type=script&lang=js&"
export * from "./Departments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d374bab",
  null
  
)

export default component.exports